import gql from 'graphql-tag';

export const GET_MERCHANT_PERFORMANCE_YEAR_OVER_YEAR = gql`
  query MerchantPerformanceYearOverYear($params: ReportInput!) {
    merchantPerformanceYearOverYear(params: $params) {
      merchantId
      aov
      totalTransactions
      onlineTransactions
      inStoreTransactions
      totalSales
      onlineSales
      inStoreSales
      cashbackAmount
      date
    }
  }
`;

export default GET_MERCHANT_PERFORMANCE_YEAR_OVER_YEAR;
